import { z } from 'zod';

import { BusinessStructure, TrustType } from '@paid-ui/enums/business';

export const trustTypeSchema = z
  .nativeEnum(TrustType)
  .or(z.literal(''))
  .refine((v) => v !== '', {
    message: 'Required field',
  });

export const businessStructureSchema = z
  .nativeEnum(BusinessStructure)
  .or(z.literal(''))
  .refine((v) => v !== '', {
    message: 'Required field',
  });
